import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInfoSimple: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="info-simple, tooltip, information"><circle cx="12" cy="5.5" r="1.5" fill="currentColor"/><path d="M9 10.25H12V19.25M12 19.25H9M12 19.25H15" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconInfoSimple;
